export default "__VITE_PUBLIC_ASSET__59910adf__"